import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class FileResource {
  private baseUri = '/prl/files';

  constructor(private ApiService: ApiService) {}

  // PUT
  removePatientFolderFile(params: {
    patientFolderId: Docorga.interfaces.naturalTypes.NPatientFolderObjectId;
    file: Docorga.interfaces.file.IFileJson;
    fileKey: 'ordonnance' | 'followUps';
    followUpsItem?: number;
  }): Observable<void> {
    return this.ApiService.put(`${this.baseUri}/${params.file._id}/removePatientFolderFile`, params);
  }
}
